import { Paper, Stack, Typography } from "@mui/material";
import useResponsive from "src/hooks/useResponsive";

import { useGetLink } from "../hooks/useGetLink";
import CopyIcon from "./CopyIcon";

// ----------------------------------------------------------------------

export const PaperLink = () => {
	const isMobile = useResponsive("down", "sm");
	const { link } = useGetLink();

	return (
		<Paper sx={{ p: 3, backgroundColor: "primary.lighter", mt: 2 }}>
			<Stack
				flexDirection={"row"}
				alignItems={{ xs: "center", sm: "flex-start" }}
				justifyContent={{ xs: "center", sm: "space-between" }}
				gap={2}
			>
				<Typography
					variant={isMobile ? "subtitle2" : "body2"}
					color='primary.dark'
					sx={{
						wordWrap: "break-word"
					}}
				>
					{isMobile ? "Copia aquí tu URL" : link}
				</Typography>
				<CopyIcon />
			</Stack>
		</Paper>
	);
};

export default PaperLink;
